<template>
      <v-app>
     <v-container fill-height fluid>
      <v-row align="center" justify="center">
        
        <v-col cols="12" sm="12" md="4" lg="4">
            <div class="text-center">
              <h3 class="mb-4">Cam-Tool</h3>
            </div>
            <div class="text-center">
                <vue-telegram-login 
                mode="callback"
                telegram-login="CamLoginBot"
                @callback="login" />
           </div>
        </v-col>
        <!-- <v-col cols="12" sm="12" md="4" lg="4">
            <v-btn @click="saveUser(1,2)">Save</v-btn>
        </v-col> -->
        </v-row>
    </v-container>
       
    
  </v-app>
      
    
 </template>
    
    <script>
    import { vueTelegramLogin } from "vue-telegram-login";
    import axios from 'axios'
    export default {
      name: "your-component",
      components: { vueTelegramLogin },
      data (){
        return {
          userInfo : ''
        }
      },
      created() {
        var hasLogin = localStorage.getItem('hasLogin')


        if (hasLogin) {

          this.$router.push('dashboard')
        }

      },
      mounted(){
        // this.getUser();
      },
      methods: {
        login(user) {
  
    
        //   // gets user as an input
        //   // id, first_name, last_name, username,
        //   // photo_url, auth_date and hash      
          //  console.log(user);
          var id_tele = user['id'];
          var username = user['username'];
          this.saveUser(id_tele,username);
        },
        getUser(){
          this.userInfo = this.$cookies.get('usertg')
          console.log(this.userInfo)
        },
        logout(){

        },
        saveUser(id_tele,username){

          var bodyFormData = new FormData();
          bodyFormData.append('id_tele', id_tele);
          bodyFormData.append('username', username);
           axios.post('https://v2.thecamtool.com/user/loginwithtelegram', bodyFormData).then((data) => {

            this.$store.commit("setAuthentication", true);
            this.$router.push({ name: "dashboard" });
            window.localStorage.setItem('info', JSON.stringify(data.data))
            window.localStorage.setItem('hasLogin', true)


        }).catch((error) => {


       

        }).finally((data)=>{
      
        })

        }
      }
    };
    </script>
    